// src/models/admin/Permission.ts

export interface PermissionDefinition {
  name: Permissions; // Human-readable name (e.g., "View Users")
  description: string; // Detailed description of what the permission allows
}

export interface UserPermission {
  permissionName: Permissions; // Corresponds to PermissionDefinition.id
  granted: boolean; // True if the user has this permission, false otherwise
}

export type UserPermissions = {
  [K in Permissions]?: boolean;
};

// Interface for the payload when updating user permissions
export interface UserPermissionUpdate {
  permissionName: Permissions;
  granted: boolean;
}

export enum Permissions {
  AdminUserCreation = 'Admin User Creation',
  ContactCreation = 'Contact Creation',
  ContentCreation = 'Content Creation',
  ContentPublication = 'Content Publication',
  AIContentAssistance = 'AI Content Assistance',
  FundOpportunityCreation = 'Fund Opportunity Creation',
  InvestorCandidateCreation = 'Investor Candidate Creation',
  InvestorPromotion = 'Investor Promotion',
  FundOpportunityPromotion = 'Fund Opportunity Promotion',
  FundOpportunityFinanceUpdates = 'Fund Opportunity Finance Updates',
  AIEntityCreation = 'AI Entity Creation',
  EditGlobalConfiguration = 'Edit Global Configuration',
  AIDeveloper = 'AI Developer',
  NewsArticleCreation = 'News Article Creation',
  NewsArticleApproval = 'News Article Approval',
  InvestorStatements = 'Investor Statements',
  DocumentCategoriesAdd = 'Add Document Categories',
  DocumentCategoriesManage = 'Manage Document Categories',
  ViewClientExceptions = 'View Client Exceptions',
}
